export default __webpack_public_path__ + "static/media/logo.8c98d067.png";